function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import yoda from '@ks/yoda-js-sdk';
import * as queryString from 'querystring';
import { getFailOverUrl } from '@kibt/web-utils/fail-over';
import { logger } from './logger';
import { isURL, isLogin } from './device';
import { isJinx, judgeIsCreativePage } from './env';
var isInBrowser = typeof window !== 'undefined';
var isProduction = process.env.NODE_ENV === 'production';
export var isInApp = yoda.isInYoda;
var bizId = new URL(window.location.href).searchParams.get('bizId') || 'creative';
export var loadUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var _yoda$webview;

    var params,
        isAbsolute,
        devInBrowser,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            isAbsolute = /^http/.test(url);
            url = addParam(url, params); // 本地开发浏览器环境标志位

            devInBrowser = isInBrowser && !isProduction;

            if (!(/^ikwai/.test(url) || devInBrowser)) {
              _context.next = 8;
              break;
            }

            if (url.indexOf('ikwai://post') !== -1) {
              logger.kwailog.plugins.radar.event({
                name: 'creative-biz',
                event_type: 'to-post'
              });
            }

            window.location.href = url;
            return _context.abrupt("return");

          case 8:
            _context.next = 10;
            return yoda.ready();

          case 10:
            (_yoda$webview = yoda.webview) === null || _yoda$webview === void 0 ? void 0 : _yoda$webview.open({
              url: isAbsolute ? url : location.origin + url
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();
export function isURL2(url) {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }

  return true;
}
export function addParam(url, params) {
  var sp = url.indexOf('?') === -1 ? '?' : '&';
  var arr = [];

  for (var key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      var value = params[key] === undefined ? '' : params[key];
      encodeURIComponent(key);
      arr.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
    }
  }

  if (arr.length) {
    url += sp + arr.join('&');
  }

  return url;
}
export function openWebview(_x2) {
  return _openWebview.apply(this, arguments);
}

function _openWebview() {
  _openWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    var query,
        options,
        queryArr,
        queryStr,
        joiner,
        defaultOptions,
        launchOptions,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            options = _args3.length > 2 ? _args3[2] : undefined;
            queryArr = Object.entries(query).map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  key = _ref4[0],
                  value = _ref4[1];

              return "".concat(key, "=").concat(value);
            });
            queryArr.push('webview=yoda');
            queryStr = queryArr.join('&');
            joiner = url.indexOf('?') !== -1 ? '&' : '?';
            url += joiner + queryStr;
            defaultOptions = {
              topBarBgColor: '#f7f7fa',
              webviewBgColor: '#d2d2d4',
              titleColor: '#222222',
              topBarPosition: 'default',
              statusBarColorType: 'dark'
            };
            launchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
            _context3.next = 11;
            return yoda.ready();

          case 11:
            yoda.webview.open({
              url: url,
              launchOptions: launchOptions
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _openWebview.apply(this, arguments);
}

export function openFeedback() {
  loadUrl(getFailOverUrl('https://app.kwai.com/feedback?hyId=feedback&channel=8&feedbackSource=creatorcenter'));
}
export function parseQuery(link) {
  link = link || window.location.search;
  var query = {};
  var search = link.replace(/^\?/g, '');

  if (!search) {
    return {};
  }

  var a = search.split('&');
  var iequ;
  var value = null;

  for (var i = 0, len = a.length; i < len; i++) {
    // 必须用indexOf，不用使用split('=')
    iequ = a[i].indexOf('=');

    if (iequ < 0) {
      iequ = a[i].length;
      value = true;
    } else {
      value = decodeURIComponent(a[i].slice(iequ + 1));
    }

    query[decodeURIComponent(a[i].slice(0, iequ))] = value;
  }

  return query;
}
/**
 *
 * @param path           打开的链接 /creator/center${}
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */

export function openCreatorWebview(_x3) {
  return _openCreatorWebview.apply(this, arguments);
}
/**
 *
 * @param path           打开的链接
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */

function _openCreatorWebview() {
  _openCreatorWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
    var query,
        launchOptions,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            query = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            launchOptions = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            return _context4.abrupt("return", openWebviewBase('/creator/center', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: bizId
            }), launchOptions));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _openCreatorWebview.apply(this, arguments);
}

export function openCreativeWebview(_x4) {
  return _openCreativeWebview.apply(this, arguments);
}
/**
 * 隐藏导航栏的
 * @param path           打开的链接
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */

function _openCreativeWebview() {
  _openCreativeWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path) {
    var query,
        launchOptions,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            query = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            launchOptions = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            return _context5.abrupt("return", openWebviewBase('', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: bizId
            }), launchOptions));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _openCreativeWebview.apply(this, arguments);
}

export function openHideBarWebview(_x5) {
  return _openHideBarWebview.apply(this, arguments);
}
/**
 *
 * @param path           打开的链接 /creator/center${}
 * @param query         需要拼接在url上的参数
 * @param launchOptions webview 相关的配置
 */

function _openHideBarWebview() {
  _openHideBarWebview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path) {
    var query,
        launchOptions,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            query = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            launchOptions = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
            return _context6.abrupt("return", openWebviewBase('', path, _objectSpread(_objectSpread({}, query), {}, {
              bizId: 'hideBar'
            }), launchOptions));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _openHideBarWebview.apply(this, arguments);
}

export function openWebviewBase() {
  return _openWebviewBase.apply(this, arguments);
} // 支持端外

function _openWebviewBase() {
  _openWebviewBase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var prefix,
        path,
        query,
        launchOptions,
        finalLaunchOptions,
        url,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            prefix = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
            path = _args7.length > 1 ? _args7[1] : undefined;
            query = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
            launchOptions = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : {};
            finalLaunchOptions = _objectSpread({}, launchOptions);
            url = "".concat(location.origin).concat(prefix).concat(path, "?").concat(queryString.stringify(_objectSpread({
              webview: 'yoda',
              source: 'CREATOR_CENTER'
            }, query))); // 现在改为端外也能打开了

            if (!isInApp) {
              _context7.next = 13;
              break;
            }

            _context7.next = 9;
            return yoda.ready();

          case 9:
            _context7.next = 11;
            return yoda.webview.open({
              url: url,
              launchOptions: finalLaunchOptions
            });

          case 11:
            _context7.next = 14;
            break;

          case 13:
            // window.open(url);
            window.location.href = url;

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _openWebviewBase.apply(this, arguments);
}

export function openCreatorPage(ctx, path) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var launchOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (yoda.isInYoda) {
    openCreatorWebview(path, query, launchOptions);
  } else {
    var url = "".concat(location.origin, "/creator/center").concat(path, "?").concat(queryString.stringify(_objectSpread({
      webview: 'yoda',
      bizId: bizId,
      source: 'CREATOR_CENTER'
    }, query)));
    location.href = url;
  }
} // 统一处理

export function loadCreatorUrl(_x6, _x7) {
  return _loadCreatorUrl.apply(this, arguments);
} // 新版的loadUrl，比loadUrl多了一些功能,以后都用这个
// 1.jinx环境下创中域名替换，有利于测试
// 2.新增备用域名替换

function _loadCreatorUrl() {
  _loadCreatorUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, params) {
    var myUrl;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (isURL(url)) {
              loadUrl(url, params);
            } else {
              myUrl = url.startsWith('/') ? url : "/".concat(url);

              if (myUrl.startsWith('/creator/')) {
                openCreativeWebview(myUrl, params);
              } else {
                openCreatorWebview(myUrl, params);
              }
            }

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _loadCreatorUrl.apply(this, arguments);
}

export function loadNewUrl(_x8, _x9) {
  return _loadNewUrl.apply(this, arguments);
}

function _loadNewUrl() {
  _loadNewUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url, params) {
    var myUrl, Url;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            myUrl = '';

            if (isURL2(url)) {
              myUrl = url;
            } else {
              myUrl = url.startsWith('/') ? url : "/".concat(url);
              myUrl = myUrl.startsWith('/') ? window.location.origin + myUrl : myUrl;
            }

            myUrl = getFailOverUrl(myUrl);
            Url = new URL(myUrl);

            if (isJinx && judgeIsCreativePage(Url.href)) {
              Url.hostname = window.location.hostname;
            }

            if (isInApp) {
              loadUrl(Url.href, params);
            } else {
              window.location.href = addParam(Url.href, params || {});
            }

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _loadNewUrl.apply(this, arguments);
}

export function backOrClose() {
  return _backOrClose.apply(this, arguments);
}

function _backOrClose() {
  _backOrClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!isInApp) {
              _context10.next = 6;
              break;
            }

            _context10.next = 3;
            return yoda.ready();

          case 3:
            yoda.webview.backOrClose();
            _context10.next = 7;
            break;

          case 6:
            if (window.history.length <= 1) {
              window.close();
            } else {
              window.history.go(-1);
            }

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _backOrClose.apply(this, arguments);
}

export function webviewClose() {
  return _webviewClose.apply(this, arguments);
}

function _webviewClose() {
  _webviewClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (isInApp) {
              yoda.webview.close();
            } else {
              window.close(); // 一般来说不会到这一步

              window.history.go(-1);
            }

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _webviewClose.apply(this, arguments);
}

export function useBridge(_x10, _x11) {
  return _useBridge.apply(this, arguments);
} // 未登录需要登录,调客户端桥之后返回一个promise

function _useBridge() {
  _useBridge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(namespace, name) {
    var params,
        canuseRes,
        ret,
        _args12 = arguments;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            params = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : {};
            _context12.next = 3;
            return yoda.ready();

          case 3:
            _context12.next = 5;
            return yoda.tool.canIUse({
              namespace: namespace,
              name: name
            });

          case 5:
            canuseRes = _context12.sent;

            if (!(yoda[namespace] && yoda[namespace][name] && canuseRes.canUse)) {
              _context12.next = 11;
              break;
            }

            _context12.next = 9;
            return yoda[namespace][name](params);

          case 9:
            ret = _context12.sent;
            return _context12.abrupt("return", ret);

          case 11:
            return _context12.abrupt("return", {
              result: -404
            });

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _useBridge.apply(this, arguments);
}

export var needLogin = function needLogin() {
  var isNeedLogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isNeedLogin) {
                _context2.next = 10;
                break;
              }

              if (!yoda.isInYoda) {
                _context2.next = 9;
                break;
              }

              if (isLogin()) {
                _context2.next = 8;
                break;
              }

              _context2.next = 5;
              return yoda.ready();

            case 5:
              _context2.next = 7;
              return yoda.component.login();

            case 7:
              resolve(false);

            case 8:
              resolve(true);

            case 9:
              // 端外肯定未登录
              resolve(false);

            case 10:
              resolve(true);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x12, _x13) {
      return _ref2.apply(this, arguments);
    };
  }());
};